export const MOBILE_OS = {
  ANDROID: "ANDROID",
  IOS: "IOS",
  OTHER: "OTHER",
} as const;
